import { render, staticRenderFns } from "./ProductContractsForm.vue?vue&type=template&id=5b892f9a&"
import script from "./ProductContractsForm.vue?vue&type=script&lang=js&"
export * from "./ProductContractsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports